// The calendar has no GPS test panel. A real pickup still needs a fresh fix.
// Closing the launcher cancels late callbacks; permission is not a location.
export function requestPart3LaunchLocation({
  geolocation = globalThis.navigator?.geolocation,
  signal,
} = {}) {
  return new Promise((resolve) => {
    let settled = false;
    let timer;
    const finish = (result) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      signal?.removeEventListener("abort", cancel);
      resolve(result);
    };
    const cancel = () => finish({ status: "cancelled" });
    if (signal?.aborted) { cancel(); return; }
    if (!geolocation?.getCurrentPosition) { finish({ status: "unavailable" }); return; }
    signal?.addEventListener("abort", cancel, { once: true });
    timer = setTimeout(() => finish({ status: "timeout" }), 16000);
    try {
      geolocation.getCurrentPosition((position) => {
        const { latitude, longitude, accuracy, speed } = position?.coords || {};
        const capturedAt = Number(position?.timestamp);
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)
            || Math.abs(latitude) > 90 || Math.abs(longitude) > 180
            || !Number.isFinite(accuracy) || accuracy < 0 || accuracy > 100
            || !Number.isFinite(capturedAt) || capturedAt <= 0
            || Date.now() - capturedAt > 60000 || capturedAt - Date.now() > 5000) {
          finish({ status: "unavailable" });
          return;
        }
        finish({ status: "granted", location: {
          latitude, longitude, accuracy_metres: accuracy,
          captured_at: new Date(capturedAt).toISOString(),
          ...(Number.isFinite(speed) && speed >= 0 ? { speed } : {}),
        } });
      }, (error) => {
        finish({ status: Number(error?.code) === 1 ? "denied"
          : Number(error?.code) === 3 ? "timeout" : "unavailable" });
      }, { enableHighAccuracy: true, maximumAge: 0, timeout: 15000 });
    } catch {
      finish({ status: "unavailable" });
    }
  });
}

export function createPart3OperationId(crypto = globalThis.crypto) {
  if (crypto?.randomUUID) return crypto.randomUUID();
  if (!crypto?.getRandomValues) throw new Error("Secure launch is unavailable. Refresh NDG and try again.");
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}

